const Contract = require('./Contract');
const Program = require('./Program');

const { formatAgeAsOfNumberToDateObj, crossBrowserNewDate } = require('./utils');

class Seat {
  constructor() {
    this.init();
  }

  init() {
    this.seat_id = undefined;
    this.name = undefined;
    this.age_group_id = undefined;
    this.agegroup_name = undefined;
    this.classroom_id = undefined;
    this.classroom_name = undefined;
    this.list_id = undefined;
    this.center_id = undefined;
    this.min_age = undefined;
    this.max_age = undefined;
    this.min_age_weeks = undefined;
    this.age_as_of = undefined;
    this.temporary = undefined;
    this.make_offers = undefined;
    this.gender = undefined;
    this.allow_no_gender = undefined;
    this.subsidies = undefined;
    this.add_date = undefined;
    this.available_date = undefined;
    this.start_date = undefined;
    this.paused = undefined;
    this.paused_until = undefined;
    this.status = undefined;
    this.payment_id = undefined;
    this.contracts = undefined;
    this.discount_amount = undefined;
    this.discount_percentage = undefined;
    this.discount_refundable_deposit = undefined;
    this.discount_reason = undefined;
    this.program = undefined;
    this.preferences = undefined;
    this.criteria = undefined;
    this.has_near_hits = undefined;
  }

  copy() {
    const cp = new Seat();

    cp.seat_id = this.seat_id;
    cp.name = this.name;
    cp.age_group_id = this.age_group_id;
    cp.agegroup_name = this.agegroup_name;
    cp.classroom_id = this.classroom_id;
    cp.classroom_name = this.classroom_name;
    cp.list_id = this.list_id;
    cp.center_id = this.center_id;
    cp.min_age = this.min_age;
    cp.max_age = this.max_age;
    cp.min_age_weeks = this.min_age_weeks;
    cp.age_as_of = this.age_as_of;
    cp.temporary = this.temporary;
    cp.make_offers = this.make_offers;
    cp.gender = this.gender;
    cp.allow_no_gender = this.allow_no_gender;
    cp.subsidies = this.subsidies;
    cp.status = this.status;
    cp.payment_id = this.payment_id;
    cp.add_date = this.add_date;
    cp.available_date = this.available_date;
    cp.start_date = this.start_date;
    cp.paused = this.paused;
    cp.paused_until = this.paused_until;
    cp.discount_amount = this.discount_amount;
    cp.discount_percentage = this.discount_percentage;
    cp.discount_refundable_deposit = this.discount_refundable_deposit;
    cp.discount_reason = this.discount_reason;
    cp.has_near_hits = this.has_near_hits;
    if (this.status) {
      cp.status = Object.assign({}, this.status);
    }
    if (this.criteria) {
      cp.criteria = Object.assign({}, this.criteria);
    }
    if (this.contracts) {
      cp.contracts = [];
      this.contracts.forEach((c) => {
        cp.contracts.push(c.copy());
      });
    }
    if (this.program) {
      cp.program = this.program.copy();
    }
    if (this.preferences) {
      cp.preferences = [];
      this.preferences.forEach((p) => {
        cp.preferences.push(Object.assign({}, p));
      });
    }

    return cp;
  }

  buildFromJSON(obj) {
    this.init();
    if (obj) {
      this.seat_id = obj.seat_id ? obj.seat_id.toString() : undefined;
      this.name = obj.name ? obj.name : undefined;
      this.age_group_id = obj.age_group_id ? obj.age_group_id.toString() : undefined;
      this.agegroup_name = obj.agegroup_name ? obj.agegroup_name : undefined;
      this.classroom_id = obj.classroom_id ? obj.classroom_id.toString() : undefined;
      this.classroom_name = obj.classroom_name ? obj.classroom_name : undefined;
      this.list_id = obj.list_id ? obj.list_id.toString() : undefined;
      this.center_id = obj.center_id ? obj.center_id.toString() : undefined;
      this.min_age = obj.min_age ? obj.min_age : undefined;
      this.max_age = obj.max_age ? obj.max_age : undefined;
      this.min_age_weeks = (obj.min_age_weeks === undefined) || (obj.min_age_weeks === null)
        ? undefined : obj.min_age_weeks;
      this.age_as_of = obj.age_as_of ? obj.age_as_of : undefined;
      this.temporary = (obj.temporary === undefined) || (obj.temporary === null)
        ? undefined : obj.temporary;
      this.make_offers = (obj.make_offers === undefined) || (obj.make_offers === null)
        ? false : obj.make_offers;
      this.gender = obj.gender ? obj.gender : undefined;
      this.allow_no_gender = (obj.allow_no_gender === undefined) || (obj.allow_no_gender === null)
        ? undefined : obj.allow_no_gender;
      this.subsidies = obj.subsidies ? Object.assign({}, obj.subsidies) : undefined;
      this.add_date = obj.add_date 
        ? crossBrowserNewDate(obj.add_date)
        : undefined;
      this.available_date = obj.available_date 
        ? crossBrowserNewDate(obj.available_date)
        : undefined;
      this.start_date = obj.start_date 
        ? crossBrowserNewDate(obj.start_date)
        : undefined;
      this.paused = (obj.paused === undefined) || (obj.paused === null)
        ? undefined : obj.paused;
      this.paused_until = obj.paused_until 
        ? crossBrowserNewDate(obj.paused_until)
        : undefined;
      this.status = obj.status ? Object.assign({}, obj.status) : undefined;
      this.payment_id = obj.payment_id ? obj.payment_id.toString() : undefined;
      this.criteria = obj.criteria ? Object.assign({}, obj.criteria) : undefined;
      this.discount_amount = (obj.discount_amount === undefined) ? undefined : obj.discount_amount;
      this.discount_percentage = (obj.discount_percentage === undefined) ? undefined : obj.discount_percentage;
      this.discount_refundable_deposit = (obj.discount_refundable_deposit === undefined) ? undefined : obj.discount_refundable_deposit;
      this.discount_reason = obj.discount_reason ? obj.discount_reason : undefined;
      this.has_near_hits = (obj.has_near_hits === undefined) || (obj.has_near_hits === null) ? undefined : obj.has_near_hits;
      if (obj.contracts) {
        this.contracts = [];
        obj.contracts.forEach((c) => {
          const contract = new Contract();
          contract.buildFromJSON(c);
          this.contracts.push(contract);
        });
      }
      if (obj.program) {
        this.program = new Program();
        this.program.buildFromJSON(obj.program);
      }
      if (obj.preferences) {
        this.preferences = [];
        obj.preferences.forEach((p) => {
          const pref = {};
          Object.keys(p).forEach((k) => {
            if (p[k] !== null) {
              pref[k] = p[k];
            }
          });
          this.preferences.push(pref);
        });
        this.preferences.sort((a, b) => a.priority - b.priority);
      }
    }
  }

  toString() {
    let result = this.seat_id ? this.seat_id : '';
    return result;
  }

  getId() {
    return this.seat_id;
  }

  setId(seat_id) {
    this.seat_id = seat_id ? seat_id.toString() : undefined;
  }

  getName() {
    return this.name;
  }

  setName(name) {
    this.name = name;
  }

  getAgeGroupId() {
    return this.age_group_id;
  }

  setAgeGroupId(age_group_id) {
    this.age_group_id = age_group_id ? age_group_id.toString() : undefined;
  }

  getAgeGroupName() {
    return this.agegroup_name;
  }

  setAgeGroupName(agegroup_name) {
    this.agegroup_name = agegroup_name;
  }

  getClassroomId() {
    return this.classroom_id;
  }

  setClassroomId(classroom_id) {
    this.classroom_id = classroom_id ? classroom_id.toString() : undefined;
  }

  getClassroomName() {
    return this.classroom_name;
  }

  setClassroomName(classroom_name) {
    this.classroom_name = classroom_name;
  }
  
  getListId() {
    return this.list_id;
  }

  setListId(list_id) {
    this.list_id = list_id ? list_id.toString() : undefined;
  }

  getCenterId() {
    return this.center_id;
  }

  setCenterId(center_id) {
    this.center_id = center_id ? center_id.toString() : undefined;
  }

  getMinAge() {
    return this.min_age;
  }

  setMinAge(min_age) {
    this.min_age = min_age;
  }

  getMaxAge() {
    return this.max_age;
  }

  setMaxAge(max_age) {
    this.max_age = max_age;
  }

  getMinAgeWeeks() {
    return this.min_age_weeks;
  }

  setMinAgeWeeks(min_age_weeks) {
    this.min_age_weeks = min_age_weeks;
  }

  getAgeAsOf() {
    if (!this.age_as_of) {
      return undefined;
    }

    return formatAgeAsOfNumberToDateObj(this.age_as_of);
  }

  getAgeAsOfFixed() {
    if (!this.age_as_of) {
      return undefined;
    }

    return (this.age_as_of > 10000);
  }

  setAgeAsOf(age_as_of, includeYear = false) {
    if (!age_as_of) {
      this.age_as_of = undefined;
    } else {
      // Pull the month and day off and set those
      // Special case - we don't allow setting February 29 (make it Feb 28)
      const date = new Date(age_as_of);
      const month = date.getUTCMonth();
      const year = includeYear ? date.getUTCFullYear() : 0;
      let day = date.getUTCDate();
      if ((month === 1) && (day > 28) && (year === 0)) {
        day = 28;
      }

      this.age_as_of = (year * 10000) + (month + 1) * 100 + day;
    }
  }

  getTemporary() {
    return this.temporary;
  }

  setTemporary(temporary) {
    this.temporary = temporary;
  }

  getMakeOffers() {
    return this.make_offers;
  }

  setMakeOffers(make_offers) {
    this.make_offers = make_offers;
  }
  
  getGender() {
    return this.gender;
  }

  setGender(gender) {
    this.gender = gender;
  }

  getAllowNoGender() {
    return this.allow_no_gender;
  }

  setAllowNoGender(allow_no_gender) {
    this.allow_no_gender = allow_no_gender;
  }

  getSubsidies() {
    return this.subsidies;
  }

  setSubsidies(subsidies) {
    this.subsidies = subsidies ? Object.assign({}, subsidies) : undefined;
  }

  getAddDate() {
    return this.add_date;
  }

  setAddDate(add_date) {
    this.add_date = add_date ? new Date(add_date) : undefined;
  }

  getAvailableDate() {
    return this.available_date;
  }

  setAvailableDate(available_date) {
    this.available_date = available_date ? new Date(available_date) : undefined;
  }

  getStartDate() {
    return this.start_date;
  }

  setStartDate(start_date) {
    this.start_date = start_date ? new Date(start_date) : undefined;
  }

  getPaused() {
    return this.paused;
  }

  setPaused(paused) {
    this.paused = paused;
  }

  getPausedUntil() {
    return this.paused_until;
  }

  setPausedUntil(paused_until) {
    this.paused_until = paused_until ? new Date(paused_until) : undefined;
  }
  
  getStatus() {
    return this.status;
  }

  setStatus(status) {
    this.status = status ? Object.assign({}, status): undefined;
  }

  getPaymentId() {
    return this.payment_id;
  }

  setPaymentId(payment_id) {
    this.payment_id = payment_id ? payment_id.toString() : undefined;
  }

  getDiscountAmount() {
    return this.discount_amount;
  }

  setDiscountAmount(discount_amount) {
    this.discount_amount = discount_amount;
  }

  getDiscountPercentage() {
    return this.discount_percentage;
  }

  setDiscountPercentage(discount_percentage) {
    this.discount_percentage = discount_percentage;
  }

  getDiscountRefundableDeposit() {
    return this.discount_refundable_deposit;
  }

  setDiscountRefundableDeposit(discount_refundable_deposit) {
    this.discount_refundable_deposit = discount_refundable_deposit;
  }
  
  getDiscountReason() {
    return this.discount_reason;
  }

  setDiscountReason(discount_reason) {
    this.discount_reason = discount_reason;
  }

  getContracts(include_private = false) {
    return include_private ? this.contracts : this.contracts.filter(c => c.is_public);
  }

  setContracts(contracts) {
    this.contracts = undefined;
    if (contracts) {
      this.contracts = [];
      contracts.forEach((c) => {
        this.contracts.push(c.copy());
      });
    }
  }
  
  getProgram() {
    return this.program;
  }

  setProgram(program) {
    this.program = undefined;
    if (program) {
      this.program = program.copy();
    }
  }

  getPreferences() {
    return this.preferences;
  }

  setPreferences(preferences) {
    if (preferences) {
      this.preferences = [];
      preferences.forEach((p) => {
        this.preferences.push(Object.assign({}, p));
      });
      this.preferences.sort((a, b) => a.priority - b.priority);
    }
  }

  getCriteria() {
    return this.criteria;
  }

  setCriteria(criteria) {
    this.criteria = (criteria) ? Object.assign({}, criteria) : undefined;
  }


  getHasNearHits() {
    return this.has_near_hits;
  }
}

module.exports = Seat;
